import { render } from "./modalFormServerItem.vue?vue&type=template&id=dfb51010"
import script from "./modalFormServerItem.vue?vue&type=script&lang=js"
export * from "./modalFormServerItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__